import ProcessWhiteboard from "./process_whiteboard.jpg";

export const processWhiteboard = {
  img: ProcessWhiteboard,
  description: "The whiteboard after completing a brainstorming activity",
};
